import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../services/account/account.service';
import { searchList } from '../../../../../utils';
import { EntryPass, EntryPassFilters, getEntryPassStatusDisplay } from '../../../../../models/entry-pass';
import { EntryPassStatus } from '../../../../../models/entry-pass-enums';
import { EntryPassService } from '../../../../../services/entry-pass/entry-pass.service';


@Component({
  selector: 'app-select-entry-pass-modal',
  templateUrl: './select-entry-pass-modal.component.html',
  styleUrls: ['./select-entry-pass-modal.component.css']
})
export class SelectEntryPassModalComponent implements OnInit {

  @Input() excludeIds: number[];
  @Input() filters: EntryPassFilters = {};
  @Input() submitCallback: (entryPass: EntryPass) => undefined;

  public loadingEntryPasses = false;
  public searchInput = '';

  public entryPasses: EntryPass[];
  public selectedEntryPass: EntryPass = null;

  public serverError: number = null;

  public EntryPassStatus = EntryPassStatus;
  public getEntryPassStatusDisplay = getEntryPassStatusDisplay;

  constructor(
    public activeModal: NgbActiveModal,
    private entryPassService: EntryPassService,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.loadEntryPasses();
  }

  public filteredEntryPasses(): EntryPass[] {
    return searchList<EntryPass>(
      this.searchInput,
      this.entryPasses.map(ep => {
        return {
          value: ep,
          searchableText: ep.name
        };
      })
    );
  }

  public handleSearchInputChange() {
    this.selectedEntryPass = null;
  }

  public selectEntryPass(ep: EntryPass) {
    this.selectedEntryPass = ep;
    this.searchInput = ep.name;
  }

  public validInputSelected() {
    return this.selectedEntryPass !== null;
  }

  public handleSave() {
    this.submitCallback(this.selectedEntryPass);
    this.activeModal.close();
  }

  private loadEntryPasses() {
    this.loadingEntryPasses = true;

    this.entryPassService
      .getEntryPasses(1, 3000, this.filters)
      .then(response => {
        this.entryPasses = response.results.filter(et => !this.excludeIds.includes(et.id));
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingEntryPasses = false; });
  }
}
